import type { Receipt } from '../../../services/financial/types';
import { downloadBlob } from '../../../shared/utils/download-blob.util';
import { formatCurrency, formatDateToBrazil } from '../../../shared/utils';
import { formatRegisterNumber } from '../../../shared/utils/format-register-number';

const STATUS_LABEL: Record<Receipt['status'], string> = {
  paid: 'Pagos',
  pending: 'Pendente',
};

const BENEFICIARY_LABEL: Record<string, string> = {
  broker: 'Corretor',
  advisory: 'Assessoria',
  insured: 'Segurado',
};

/** Escapa um campo para CSV (separador `;`, padrão pt-BR do Excel). */
const cell = (value: string) => `"${value.replace(/"/g, '""')}"`;

/**
 * Baixa os detalhes de um recibo como CSV (abre no Excel). Sem dependências —
 * gera o conteúdo com BOM UTF-8 e separador `;` para o Excel pt-BR reconhecer.
 * (Um .xlsx real exigiria uma lib/endpoint; o CSV cobre o "Detalhes em Excel".)
 */
export function downloadReceiptDetailsCsv(receipt: Receipt): void {
  const rows: Array<[string, string]> = [
    ['Recibo', String(receipt.receiptNumber)],
    ['Favorecido', receipt.favorecidoName ?? ''],
    [
      'CPF/CNPJ',
      receipt.favorecidoDocument
        ? formatRegisterNumber(receipt.favorecidoDocument)
        : '',
    ],
    [
      'Tipo de Favorecido',
      receipt.beneficiaryType
        ? (BENEFICIARY_LABEL[receipt.beneficiaryType] ??
          receipt.beneficiaryType)
        : '',
    ],
    ['Valor Líquido', formatCurrency(receipt.netValue)],
    [
      'Previsão',
      receipt.paymentForecast
        ? formatDateToBrazil(receipt.paymentForecast)
        : '',
    ],
    [
      'Pagamento',
      receipt.paymentDate ? formatDateToBrazil(receipt.paymentDate) : '',
    ],
    ['Status', STATUS_LABEL[receipt.status]],
  ];

  const csv =
    '﻿' +
    rows.map(([label, value]) => `${cell(label)};${cell(value)}`).join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  downloadBlob(blob, `detalhes-recibo-${receipt.receiptNumber}.csv`);
}
